import { useEffect, useRef, useState } from "react";
import { Icon, type IconName } from "./Icon";
import { cx } from "../lib/cx";

export interface DetailAction {
  label: string;
  icon: IconName;
  onClick: () => void;
  danger?: boolean;
}

interface DetailActionMenuProps {
  actions: DetailAction[];
}

/**
 * Floating per-detail-page action trigger (replaces the global quick-add FAB
 * on detail screens): a three-dot button that opens a small action sheet
 * with the domain's actions (edit, status, notes, delete, ...).
 */
export function DetailActionMenu({ actions }: DetailActionMenuProps) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    function onKeyDown(event: KeyboardEvent) {
      if (event.key === "Escape") setOpen(false);
    }
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [open]);

  return (
    <>
      {open && <div className="action-menu-scrim" onClick={() => setOpen(false)} />}
      {open && (
        <div className="action-menu" role="menu" ref={menuRef}>
          {actions.map((action) => (
            <button
              key={action.label}
              type="button"
              role="menuitem"
              className={cx("action-menu__item", action.danger && "action-menu__item--danger")}
              onClick={() => {
                setOpen(false);
                action.onClick();
              }}
            >
              <Icon name={action.icon} width={14} height={14} aria-hidden="true" />
              {action.label}
            </button>
          ))}
        </div>
      )}
      <button
        type="button"
        className="fab fab--menu"
        onClick={() => setOpen((value) => !value)}
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label="کنش‌های این مورد"
      >
        <Icon name="more-horizontal" width={24} height={24} strokeWidth={2.2} aria-hidden="true" />
      </button>
    </>
  );
}
